import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import "./GuideTranslate.css";
import PromptModal from "./PromptModal";
import AlertModal from "./AlertModal";
import MultiSelectModal from "./MultiSelectModal";
import { googleLanguages } from "../../Data/Languages";
import GoogleTranslate from "../../Models/GoogleTranslate";

const icoLanguage = solid("language");
const icoXmark = solid("xmark");
const icoChevR = solid("chevron-right");

class GuideTranslate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uidText: "",
      selectedLanguage: "English",
      selectedLanguageId: "en",
      schedules: true,
      event_subject: false,
      places: true,
      home_screen: true,
      sections: true,
      place_name: false,
      activityIndicator: false,

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,
    };
  }

  componentDidMount() {}

  MyAlert = (title, message, buttons) => {
    this.setState({ AlertModalTitle: title, AlertModalMessage: message, AlertModalButtons: buttons, AlertModalShow: true });
  };

  selectLanguage = () => {
    let _languages = [];
    const languages_sorted = googleLanguages.sort((a, b) => (a.language > b.language ? 1 : -1));
    let id = 1;
    languages_sorted.forEach((language) =>
      _languages.push({ label: language.language, name: language.language, value: language.id, id: (id++).toString() })
    );
    this.MultiSelect(_languages, [], "uni", this.selectedLanguage, "Select Language");
  };

  selectedLanguage = (languages) => {
    let language = "English";
    let language_id = "en";
    if (languages.length > 0) {
      language = languages[0].label;
      language_id = languages[0].value;
    }
    this.setState({ selectedLanguage: language, selectedLanguageId: language_id });
  };

  translate = () => {
    this.setState({ activityIndicator: true });
    if (this.state.schedules) {
      for (let i = 0; i < window.guide_obj.schedule.events.length; i++) {
        let event = window.guide_obj.schedule.events[i];
        if (typeof event.Body === "undefined" || event.Body === null || event.Body === "") continue;
        GoogleTranslate.translate(event.Body, this.state.selectedLanguageId, this.translateCallback, event, "event", false);
      }
    }
    if (this.state.event_subject) {
      for (let i = 0; i < window.guide_obj.schedule.events.length; i++) {
        let event = window.guide_obj.schedule.events[i];
        if (typeof event.Subject === "undefined" || event.Subject === null || event.Subject === "") continue;
        GoogleTranslate.translate(event.Subject, this.state.selectedLanguageId, this.translateCallback, event, "event_subject", false);
      }
    }
    if (this.state.places) {
      for (let i = 0; i < window.guide_obj.places.placesList.length; i++) {
        const place = window.guide_obj.places.placesList[i];
        if (typeof place.Info === "undefined" || place.Info === null || place.Info === "") continue;
        GoogleTranslate.translate(place.Info, this.state.selectedLanguageId, this.translateCallback, place, "place", false);
      }
    }
    if (this.state.place_name) {
      for (let i = 0; i < window.guide_obj.places.placesList.length; i++) {
        const place = window.guide_obj.places.placesList[i];
        if (typeof place.Name === "undefined" || place.Name === null || place.Name === "") continue;
        GoogleTranslate.translate(place.Name, this.state.selectedLanguageId, this.translateCallback, place, "place_name", false);
      }
    }
    if (this.state.sections) {
      for (let i = 0; i < window.guide_obj.chapters.length; i++) {
        const section = window.guide_obj.chapters[i];
        if (typeof section.html === "undefined" || section.html === null || section.html === "") continue;
        GoogleTranslate.translate(section.html, this.state.selectedLanguageId, this.translateCallback, section, "section", false);
      }
    }
    if (this.state.home_screen) {
      if (typeof window.guide_obj.document !== "undefined" && window.guide_obj.document !== null && window.guide_obj.document !== "")
        GoogleTranslate.translate(window.guide_obj.document, this.state.selectedLanguageId, this.translateCallback, null, "home_screen", true);
    }
    setTimeout(() => this.finish(), 7000);
  };

  translateCallback = (result, obj, type, last) => {
    try {
      if (typeof result.data.translations === "undefined") return;
      if (type === "event") obj.Body = result.data.translations[0].translatedText;
      if (type === "event_subject") obj.Subject = result.data.translations[0].translatedText;
      if (type === "place") obj.Info = result.data.translations[0].translatedText;
      if (type === "place_name") obj.Name = result.data.translations[0].translatedText;
      if (type === "section") obj.html = result.data.translations[0].translatedText;
      if (type === "home_screen") window.guide_obj.document = result.data.translations[0].translatedText;
    } catch (e) {
      console.log("translateCallback: Error in translation");
    }
  };

  finish = () => {
    let guide_attributes = JSON.parse(JSON.stringify(window.guide_obj.attributes));
    guide_attributes.language = this.state.selectedLanguage;
    window.guide_obj.attributes.modifyGuideAttributes(guide_attributes);
    this.setState({ activityIndicator: false });
    this.props.update_ui();
    this.props.onHide();
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  render() {
    const options = [
      { key: "schedules",     label: "Event Info" },
      { key: "event_subject", label: "Event Subject" },
      { key: "places",        label: "Place Notes" },
      { key: "place_name",    label: "Place Name" },
      { key: "home_screen",   label: "Itinerary" },
      { key: "sections",      label: "Sections" },
    ];

    return (
      <div className="modal" style={{ zIndex: 65537 }}>
        <Modal
          {...this.props}
          dialogClassName="gt-dialog"
          aria-labelledby="contained-modal-title-vcenter"
          centered={false}
          scrollable={false}
        >
          <Modal.Header style={{ padding: 0, border: "none", display: "block" }}>
            <div className="gt-header">
              <div className="gt-header-icon">
                <FontAwesomeIcon icon={icoLanguage} />
              </div>
              <h2 className="gt-title" id="contained-modal-title-vcenter">Translate Guide</h2>
              <button className="gt-close" onClick={this.props.onHide}>
                <FontAwesomeIcon icon={icoXmark} />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div className="gt-body">
              <span className="gt-section-label">Translate</span>
              <div className="gt-card">
                {options.map((opt, i) => (
                  <React.Fragment key={opt.key}>
                    {i > 0 && <div className="gt-divider" />}
                    <div className="gt-toggle-row">
                      <span className="gt-toggle-label">{opt.label}</span>
                      <label className="gt-toggle">
                        <input
                          type="checkbox"
                          checked={this.state[opt.key]}
                          onChange={() => this.setState({ [opt.key]: !this.state[opt.key] })}
                        />
                        <span className="gt-toggle-track" />
                        <span className="gt-toggle-thumb" />
                      </label>
                    </div>
                  </React.Fragment>
                ))}
              </div>

              <span className="gt-section-label">Language</span>
              <div className="gt-card">
                <button className="gt-selector-row" onClick={this.selectLanguage}>
                  <span className="gt-selector-label">Language</span>
                  <span className="gt-selector-value">{this.state.selectedLanguage}</span>
                  <span className="gt-selector-chevron">
                    <FontAwesomeIcon icon={icoChevR} />
                  </span>
                </button>
              </div>

              <button
                className="gt-translate-btn"
                onClick={this.translate}
                disabled={this.state.activityIndicator}
              >
                {this.state.activityIndicator
                  ? <><span className="gt-spinner" /> Translating…</>
                  : <><FontAwesomeIcon icon={icoLanguage} /> Translate</>}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
        {this.state.ShowMultiselect && (
          <MultiSelectModal
            show={this.state.ShowMultiselect}
            onHide={() => this.setState({ ShowMultiselect: false })}
            MultiselectItems={this.state.MultiselectItems}
            MultiselectSelectedItems={this.state.MultiselectSelectedItems}
            MultiselectMode={this.state.MultiselectMode}
            MultiselectCallback={this.state.MultiselectCallback}
            MultiselectTitle={this.state.MultiselectTitle}
            MultiselectSearchText={this.state.MultiselectSearchText}
          />
        )}
      </div>
    );
  }
}

export default GuideTranslate;
